import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-confirm-invoice-company-data-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-invoice-company-data-dialog.component.html',
  styleUrl: './confirm-invoice-company-data-dialog.component.scss',
})
export class ConfirmInvoiceCompanyDataDialogComponent {
  confirmed = false;
  c_f: string = '';
  iva_number: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmInvoiceCompanyDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      c_f: string;
      iva_number: string;
    }
  ) {
    this.c_f = data.c_f;
    this.iva_number = data.iva_number;

    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il suo contorno e la fascia panna delle azioni
       non sono raggiungibili da uno stile incapsulato: servono le regole
       globali di .izy-info-dialog-panel, la veste neutra dei dialog che
       informano senza distruggere niente - da qui si puo' proseguire, quindi
       NON e' la veste rossa di .izy-danger-dialog-panel: l'attenzione la
       segnala la fascia lilla del riquadro dei due campi.
       .izy-auto-height-dialog-panel toglie in piu' l'altezza fissa (370/400px)
       che i chiamanti passano alla MatDialogConfig.
       Le classi le aggiunge il componente e non il chiamante perche' i punti
       di apertura sono quattro (nuova fattura x2, dettaglio fattura, bozze) e
       la veste e' la stessa per tutti. */
    this.dialogRef.addPanelClass([
      'izy-info-dialog-panel',
      'izy-auto-height-dialog-panel',
    ]);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
